import { catColor, catLabel } from "@/lib/lore";

export const CategoryBreakdown = ({ categories }) => {
  const max = Math.max(1, ...categories.map((c) => c.count));
  return (
    <section className="rounded-md border border-[#2D3442] bg-[#0F131A] p-5" data-testid="stats-categories">
      <div className="lf-label">Your most-used categories</div>
      {!categories.length ? <p className="mt-3 text-sm text-[#A8A090]">No lore entries yet.</p> : (
        <ul className="mt-4 max-h-[420px] space-y-2.5 overflow-y-auto pr-1">
          {categories.map((c, i) => (
            <li key={c.category} data-testid={`stats-category-${c.category}`}>
              <div className="flex justify-between text-xs"><span className="text-[#D6CCBC]">{catLabel(c.category)}</span><span className="tabular-nums text-[#A8A090]">{c.count}</span></div>
              <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-[#1A202C]">
                <div className="h-full rounded-full animate-in slide-in-from-left fill-mode-both duration-700" style={{ width: `${(c.count / max) * 100}%`, background: catColor(c.category), animationDelay: `${i * 40}ms` }} />
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
